import {createAction, props} from "@ngrx/store";
import {CreateNotificationCommand, NotificationDto, UpdateNotificationCommand} from "@esa/api";

export const getNotifications = createAction(
  '[Notifications] Get Notifications',
)

export const getNotificationsSuccess = createAction(
  '[Notifications] Get Notifications Success',
  props<{ notifications: NotificationDto[] }>()
)

export const getNotificationsError = createAction(
  '[Notifications] Get Notifications Error',
)

export const createNotification = createAction(
  '[Notifications] Create Notification',
  props<{ notification: CreateNotificationCommand }>()
)

export const createNotificationSuccess = createAction(
  '[Notifications] Create Notification Success'
)

export const createNotificationError = createAction(
  '[Notifications] Create Notification Error',
)

export const updateNotification = createAction(
  '[Notifications] Update Notification',
  props<{ notification: UpdateNotificationCommand }>()
)

export const updateNotificationSuccess = createAction(
  '[Notifications] Update Notification Success'
)

export const updateNotificationError = createAction(
  '[Notifications] Update Notification Error',
)
